<template>
  <div v-if="checksDialog || successDialog || errorDialog">
    <Dialog v-model:visible="checksDialog" class="irinox-dialog-missing-data" :modal="true" :dismissableMask="true"
      :closable="true" :style="{ width: '590px' }" :draggable="false" >

      <template #header>
        <div>{{ $t('account.missing_data') }}</div>
      </template>
  
      <div class="irinox-dialog-missing-data-content">
        
        <div class="p-d-flex p-flex-column">
          <Divider align="center" >
              <b>{{$t('signup.section_company')}}</b>
          </Divider>

          <label for="signup.taxCode">{{$t('signup.taxCode')}}</label>
          <InputText id="signup.taxCode" type="text" v-model="company.taxCode" 
            :placeholder="$t('signup.taxCode_ph')"
            :class="{'p-invalid':v$.company.taxCode.$invalid && submitted}"/>

          <label for="signup.sector">{{$t('signup.sector')}}</label>
          <Dropdown id="signup.sector" v-model="company.sector" :options="sectors" optionLabel="name" optionValue="code" 
            :placeholder="$t('signup.sector_ph')"
            :class="{'p-invalid':v$.company.sector.$invalid && submitted}" />

          <label for="signup.countryCompany">{{$t('signup.country')}}</label>
          <Dropdown id="signup.countryCompany" v-model="company.country" :options="countries" optionLabel="name" optionValue="code" :filter="true"
            :placeholder="$t('signup.country_ph')"
            :class="{'p-invalid':v$.company.country.$invalid && submitted}" 
            @change="resetOptionalRegistrationFields()"/>

          <label v-if="company.country==='IT'" for="signup.district">{{$t('signup.district')}}</label>
          <InputText v-if="company.country==='IT'" id="signup.district" type="text" v-model="company.district" 
            :placeholder="$t('signup.district_ph')"
            :class="{'p-invalid':v$.company.district.$invalid && submitted}"/>
            
          <label for="signup.city">{{$t('signup.city')}}</label>
          <InputText id="signup.city" type="text" v-model="company.city" 
          :placeholder="$t('signup.city_ph')"
          :class="{'p-invalid':v$.company.city.$invalid && submitted}"/>
            
          <label v-if="company.country==='DE'" for="signup.postalCode">{{$t('signup.postalCode')}}</label>
          <InputText v-if="company.country==='DE'" id="signup.district" type="text" v-model="company.postalCode" 
            :placeholder="$t('signup.postalCode_ph')"
            :class="{'p-invalid':v$.company.postalCode.$invalid && submitted}"/>
           
          <label for="signup.phone">{{$t('signup.phone')}}</label>
          <InputText id="signup.phone" type="text" v-model="company.phone" 
            :placeholder="$t('signup.phone_ph')"
            :class="{'p-invalid':v$.company.phone.$invalid && submitted}"/>

        </div>
  
      </div>
  
      <template #footer>
        <Button :label="$t('company.save_button')" autofocus @click="save(!v$.$invalid)" />
      </template>
    </Dialog>
  
    <IrinoxDialogDark :visible="successDialog" mode="success" :message="$t('account.missing_data_success')"
      :life="3000" @update:visible="successDialog = $event"></IrinoxDialogDark>
  
    <IrinoxDialogDark :visible="errorDialog" mode="error" :message="$t('company.error_dialog')"
      :life="3000" @update:visible="errorDialog = $event"></IrinoxDialogDark>
  </div>

</template>

<script>
import { mapGetters } from 'vuex';
import AccountService from '../../service/AccountService';
import CountryService from '../../service/CountryService';
import { required, requiredIf, minLength } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
export default {
    components: {
        IrinoxDialogDark,
    },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      checksDialog: false,
      company: {},
      countries: [],
      sectors: [{
        name: this.$t('company.sectors.dealer'),
        code: "dealer"
      }, {
        name: this.$t('company.sectors.consultant'),
        code: "consultant"
      }, {
        name: this.$t('company.sectors.gastronomy'),
        code: "gastronomy"
      }, {
        name: this.$t('company.sectors.bakery'),
        code: "bakery"
      }, {
        name: this.$t('company.sectors.pastry'),
        code: "pastry"
      }, {
        name: this.$t('company.sectors.pastry_bakery'),
        code: "pastry_bakery"
      }, {
        name: this.$t('company.sectors.icecream'),
        code: "icecream"
      }, {
        name: this.$t('company.sectors.foodchain'),
        code: "foodchain"
      }, {
        name: this.$t('company.sectors.catering'),
        code: "catering"
      }, {
        name: this.$t('company.sectors.schoolcooking'),
        code: "schoolcooking"
      }, {
        name: this.$t('company.sectors.foodindustry'),
        code: "foodindustry"
      }, {
        name: this.$t('company.sectors.hotel'),
        code: "hotel"
      }, {
        name: this.$t('company.sectors.largedistribution'),
        code: "largedistribution"
      }, {
        name: this.$t('company.sectors.nonfoodsector'),
        code: "nonfoodsector"
      }, {
        name: this.$t('company.sectors.assistance'),
        code: "assistance"
      },{
        name: this.$t('company.sectors.manufacturerepresentative'),
        code: "manufacturerepresentative"
      }, {
        name: this.$t('company.sectors.other'),
        code: "other"
      }],
      submitted: true,
      successDialog: false,
      errorDialog: false,
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      refreshtoken: 'userdata/refreshtoken',
      email: 'userdata/email',
      role: 'userdata/role',
    }),
    idpUserId: function () {
      return this.$store.state.userdata.idpUserId;
    },
  },
    validations() {
        return {
            company: {
              taxCode: {
                  required: requiredIf(function() {
                    return this.signup.company.country!=='US'
                  }),
                  minLength: minLength(2),
                  valid: this.$functions.taxCodeCheck
              },
              sector: {
                  required
              },
              country: {
                  required
              },
              district: {
                required: requiredIf(function() {
                      return this.company.country==='IT'
                    })
              },
              city: {
                  required
              },
              postalCode: {
                required: requiredIf(function() {
                      return this.company.country==='DE'
                    })
              },
              phone: {
                  required
              },
            }
        }
    },
    watch: {
    },
  created() {
    this.countryService = new CountryService();
    this.accountService = new AccountService();
  },
  mounted() {
    if (this.idpUserId != null && this.role == 'USER') {
      this.getCompany();
    }
  },
  methods: {
    resetOptionalRegistrationFields() {
      this.company.district = null;
      this.company.postalCode = null;
    },
    getCompany() {
        this.accountService.getCompany(this.personaltoken)
          .then(company => {
            this.company = company;
            if((!this.company.taxCode && this.signup.company.country!=='US') || 
                    !this.company.sector || 
                    !this.company.country || 
                    !this.company.city || 
                    !this.company.phone) {
              this.getCountries();
              this.checksDialog = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
          });
      },
    getCountries() {
      this.countryService.getCountries().then((countries) => {
            this.countries = countries;
        });
    },
    save(isFormValid) {
        this.submitted = true;

        if (!isFormValid) {
          return;
        }

        let updateData = {};
        updateData.name = this.company.name;
        updateData.sector = this.company.sector;
        updateData.type = this.company.type;
        updateData.country = this.company.country;
        updateData.city = this.company.city;
        updateData.address = this.company.address;
        updateData.district = this.company.district;
        updateData.postalCode = this.company.postalCode;
        updateData.phone = this.company.phone;
        updateData.taxCode = this.company.taxCode;

        this.accountService.putCompany(this.personaltoken, updateData)
        .then(() => {
            this.checksDialog = false;
            this.successDialog = true;
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.checksDialog = false;
            this.errorDialog = true;
            // setTimeout(function() {
            //   this.checksDialog = true;
            // }.bind(this),3000);
          });
      }
  }
}
</script>

<style scoped>

* :deep(.p-dropdown-label.p-placeholder) {
    color: grey;
}
* :deep(input) {
    font-size: 17px;
}
* :deep(.p-dropdown-label) {
    font-size: 17px;
}


</style>